import { cn } from '@/lib/cn';
import type { PortalStep } from '@/lib/queries';

const DOT: Record<PortalStep['state'], string> = {
  done: 'bg-emerald-500', current: 'bg-accent-500 ring-4 ring-accent-500/25', blocked: 'bg-red-500 ring-4 ring-red-500/25', pending: 'bg-slate-800 border border-slate-700',
};
const day = (iso?: string | null) => iso ? new Date(iso).toLocaleDateString('en-AE', { day: 'numeric', month: 'short' }) : '';

/** The client-safe step line: one dot per step, the current one lit, dates under the done ones. */
export default function StepLine({ steps, dates = false }: { steps: PortalStep[]; dates?: boolean }) {
  return (
    <div className="flex items-center gap-1 mt-2 overflow-x-auto" data-testid="step-line">
      {steps.map((s, i) => (
        <div key={s.key} className="flex items-center shrink-0" title={s.label + (s.at ? ` · ${day(s.at)}` : '')}>
          <div className="flex flex-col items-center gap-1 w-16">
            <div className={cn('w-3 h-3 rounded-full', DOT[s.state])} />
            <div className={cn('text-[9px] leading-tight text-center', s.state === 'pending' ? 'text-muted/60' : s.state === 'current' ? 'text-accent-300' : 'text-muted-strong')}>{s.label}</div>
            {dates && <div className="text-[9px] leading-none text-muted/70 tabular-nums h-2">{s.state === 'done' && s.at ? day(s.at) : ''}</div>}
          </div>
          {i < steps.length - 1 && <div className={cn('h-px w-4', dates ? '-mt-6' : '-mt-4', s.state === 'done' ? 'bg-emerald-500/50' : 'bg-slate-800')} />}
        </div>
      ))}
    </div>
  );
}
